import { render } from "./HomeOld.vue?vue&type=template&id=3efa2047&scoped=true"
import script from "./HomeOld.vue?vue&type=script&lang=js"
export * from "./HomeOld.vue?vue&type=script&lang=js"

import "./HomeOld.vue?vue&type=style&index=0&id=3efa2047&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1728185854/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efa2047"]])

export default __exports__